A preview of a prospective job ad as it would appear on a SEEK job board.

This query accepts browser tokens that include the `query:posted-position-profile-previews` or `query:enhanced-job-posting` scope.
